import { NavLink, Outlet } from 'react-router-dom';

function ConsoleLayout({ user, onLogout }) {
  return (
    <div className="min-h-screen bg-neutral-100 dark:bg-neutral-950 text-neutral-900 dark:text-neutral-100 flex">
      {/* Sidebar */}
      <aside className="w-56 shrink-0 bg-white dark:bg-neutral-900 border-r border-neutral-200 dark:border-neutral-800 flex flex-col">
        <div className="p-4 border-b border-neutral-200 dark:border-neutral-800">
          <h1 className="text-lg font-bold tracking-tight">VI Console</h1>
        </div>

        <nav className="flex-1 p-3 space-y-1">
          <SidebarLink to="/" end>Events</SidebarLink>
          <SidebarLink to="/cameras">Cameras</SidebarLink>
        </nav>

        <div className="p-4 border-t border-neutral-200 dark:border-neutral-800">
          <p className="text-xs text-neutral-500 truncate mb-2">{user?.email}</p>
          <button
            onClick={onLogout}
            className="text-xs text-neutral-500 hover:text-red-500 transition-colors"
          >
            Sign Out
          </button>
        </div>
      </aside>

      {/* Content */}
      <main className="flex-1 p-6 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}

function SidebarLink({ to, end, children }) {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        `block px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
          isActive
            ? 'bg-neutral-100 dark:bg-neutral-800 text-neutral-900 dark:text-white'
            : 'text-neutral-600 dark:text-neutral-400 hover:bg-neutral-50 dark:hover:bg-neutral-800/50'
        }`
      }
    >
      {children}
    </NavLink>
  );
}

export default ConsoleLayout;
